<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/dbYhig/tc-custom/9780061969447.jpg?1718044388564" alt="This image is the cover for the book Everything Here Is the Best Thing Ever"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Everything Here Is the Best Thing Ever
      </h1>
      <p class="bookDescription body article font2">
        <p><b>“This spare, sharp book—Taylor’s debut collection—documents a deep authority on the unavoidable confusion of being young, disaffected and human … the most affecting stories in <i>Everything Here Is the Best Thing Ever</i> are as unpredictable as a careening drunk. They leave us with the heavy residue of an unsettling strangeness, and a new voice that readers—and writers, too—might be seeking out for decades to come.” — <i>New York Times Book Review</i></b></p><p><b>A collection of prophetic, provocative, and dazzlingly written stories by Justin Taylor, an important new voice in literary fiction and "a new literary beast." (Padgett Powell, author of <i>The Interrogative Mood</i>)</b></p><p>Each story in this crystalline, spare, and moving collection cuts to the quick. Taylor’s characters are guided by misapprehensions that bring them to hilarious, often tragic impasses with reality. A high school boy's desire to win over a crush leads him to experiment with black magic. An assistant at a hedge fund is torn between the girl he loved in college and the older man whose attention he craves. A fast food employee preoccupied by Abu Ghraib grows obsessed with a co-worker. While his girlfriend sleeps, a Tetris player tries to beat his record, nevermind that out their window blazes the end of the world.</p><p>Fearless and wild, the stories of <i>Everything Here Is the Best Thing Ever </i>are held together by a thread of wounding humor and candid storytelling that marks Taylor as a distinct and emerging literary talent.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Justin Taylor
      </h2>
      
      <p class="authorDescription body article"><P>Justin Taylor is the author of the story collection <I>Everything Here Is the Best Thing Ever</I> and the novel <I>The Gospel of Anarchy</I>. He lives in New York City.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      HarperCollins
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3390f4a2